import React, {FC} from 'react';
import styled from 'styled-components';

import {BillingUpgradeDiamondIcon} from '../../../../../../../libs/shared/billing/web/src/components/billingUpgradeDiamondIcon';
import {Trans} from '../../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {StartAndEndDates} from '../../../../../../../libs/shared/core/src/helpers/models/dateIntervalModels';
import {boxedInputColorReaders} from '../../../../../../../libs/shared/ui/src/components/boxedInputs/boxedInputConstants';
import {DropdownBoxCoordinator} from '../../../../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {DateRangeComboBoxDropdown} from '../../../../../../../libs/shared/ui/src/components/datetime/dateRangeComboBoxDropdown';
import {useUserTheme} from '../../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {useAppSelector} from '../../../../../../helpers/appReduxHelpers';
import {getCalendarWeekStartDay} from '../../../../../../store/data/preferences/preferencesSelectors';
import {
  customSearchHintPeriods,
  DateTitle,
  getSelectedDateRangePeriod,
} from '../../../hints/searchHintDate/searchHintDate';

/*
 * Props.
 */

interface SearchDateFieldProps {
  selectedDateRange: StartAndEndDates | undefined;
  setDatePeriod: (dates: StartAndEndDates) => void;
  clearDatePeriod: () => void;
}

/*
 * Styles.
 */

const StyledPlaceholderSpan = styled.span`
  color: ${boxedInputColorReaders.textPlaceholder};
`;

export const SearchDateField: FC<SearchDateFieldProps> = (props) => {
  const {selectedDateRange, setDatePeriod, clearDatePeriod} = props;

  const calendarWeekStartDay = useAppSelector(getCalendarWeekStartDay);
  const rangePeriod = getSelectedDateRangePeriod(selectedDateRange);
  const theme = useUserTheme();

  return (
    <DropdownBoxCoordinator
      shouldDisablePadding
      leftIcon="dateSmall"
      leftIconColor={selectedDateRange ? theme.greys.shade90 : undefined}
      value={
        !selectedDateRange ? (
          <StyledPlaceholderSpan>
            <Trans id="search-query-builder-date-placeholder">Select date</Trans>
          </StyledPlaceholderSpan>
        ) : (
          <DateTitle
            selectedPeriod={rangePeriod}
            startDate={selectedDateRange?.startDate}
            endDate={selectedDateRange?.endDate}
          />
        )
      }
      renderDropdown={(popoverProps) => (
        <DateRangeComboBoxDropdown
          popoverTransferProps={popoverProps}
          onDateSelect={(date) => {
            setDatePeriod(date);
            popoverProps.onRequestClose();
          }}
          selectedPeriod={rangePeriod?.period.period}
          calendarWeekStartDay={calendarWeekStartDay}
          onCancel={popoverProps.onRequestClose}
          startDate={selectedDateRange?.startDate}
          endDate={selectedDateRange?.endDate}
          shouldHideLabel
          hasCheckbox
          hasSlidingWindow
          customPeriods={customSearchHintPeriods}
          onClearButtonClick={() => {
            clearDatePeriod();
            popoverProps.onRequestClose();
          }}
          confirmButtonLabel={<Trans id="apply">Apply</Trans>}
          renderTimePeriodUnavailableIndicator={() => <BillingUpgradeDiamondIcon />}
        />
      )}
    />
  );
};
